import React from "react";
import { Link } from "react-router-dom";

import styles from "./Homepage.module.scss";

import {
  PrismicRichText,
  useAllPrismicDocumentsByType,
} from "@prismicio/react";

const Homepage = () => {
  const [movies] = useAllPrismicDocumentsByType("movies");

  // console.log(movies && movies.map((movie) => movie));

  return (
    <div className={styles.movies}>
      <h2>Prime Telugu Movies</h2>
      <span>
        {movies &&
          movies.map((movie, index) => (
            <div key={index} className={styles.movieCard}>
              <div className={styles.left}>
                <img
                  src={`${movie.data.thumbnail.url}`}
                  alt={`${movie.data.thumbnail.url}`}
                  className={styles.thumbnail}
                />
                <PrismicRichText
                  field={movie.data.title}
                  className={styles.title}
                />
                <span className={styles.rating}>
                  Rating: {movie.data.rating}
                </span>
                <br />
                <div className={styles.category}>
                  <span>category:&ensp;</span>
                  {movie.data.category.map((category, index) => (
                    <p key={index}>{category.name.slug}&emsp;</p>
                  ))}
                </div>
                <br />
                <Link to={`/moviedetails/${movie.uid}`} className={styles.link}>
                  View Details...
                </Link>
              </div>
              <div className={styles.right}>
                <PrismicRichText
                  field={movie.data.description}
                  className={styles.description}
                />
              </div>
            </div>
          ))}
      </span>
    </div>
  );
};

export default Homepage;
